export enum CroisementÉtat {
  A_FAIRE = 'AFaire',
  EN_COURS = 'EnCours',
  TERMINE = 'Terminé',
}
